exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.validation-text[data-v-6f5e3845] {\n  color: red;\n  font-size: 0.75em;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/share/form/TextareaInput.vue"],"names":[],"mappings":";AAoFA;EACE,WAAU;EACV,kBAAiB;CAClB","file":"TextareaInput.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.validation-text {\n  color: red;\n  font-size: 0.75em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f5e3845","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/share/form/TextareaInput.vue
// module id = s7C8
// module chunks = 8